/* global window */
import url from 'node:url';
import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { connect } from 'react-redux';
import { selectFromConfig } from '@gandi/redux-config';
import { getDisplayName, getDataDependency } from 'gandi.react-helpers';
import { selectIsAuthenticatedUser } from '../modules';
import { jsx as _jsx } from "react/jsx-runtime";
const selectComputedFetcherEndpoint = selectFromConfig('computedFetcherEndpoint', '');
const mapStateToProps = state => ({
  computedFetcherEndpoint: selectComputedFetcherEndpoint(state),
  isAuthenticatedUser: selectIsAuthenticatedUser(state)
});
export function handleRedirect({
  req,
  res,
  getState
}) {
  const props = mapStateToProps(getState());

  // Authenticate if not authenticated.
  if (!props.isAuthenticatedUser) {
    const publicApiEndpoint = props.computedFetcherEndpoint;
    let redirectUrl = url.format({
      protocol: req.protocol,
      host: req.hostname,
      pathname: req.path,
      query: req.query
    });
    redirectUrl = encodeURIComponent(redirectUrl);
    const loginUrl = `${publicApiEndpoint}/login?redirect=${redirectUrl}`;
    res.redirect(loginUrl);
    return Promise.reject(new Error(`needsAuth: Redirect to ${loginUrl}`));
  }
  return Promise.resolve();
}
export default WrappedComponent => {
  class NeedsAuthComponent extends React.PureComponent {
    UNSAFE_componentWillMount() {
      if (this.props.isAuthenticatedUser) {
        return;
      }
      if (typeof window !== 'undefined') {
        const publicApiEndpoint = this.props.computedFetcherEndpoint;
        const redirectUrl = encodeURIComponent(window.location.href);
        const loginUrl = `${publicApiEndpoint}/login?redirect=${redirectUrl}`;
        window.location.assign(loginUrl);
      }
    }
    render() {
      return this.props.isAuthenticatedUser ? /*#__PURE__*/_jsx(WrappedComponent, {
        ...this.props
      }) : null;
    }
  }

  // $FlowFixMe[underconstrained-implicit-instantiation]
  const NeedsAuth = connect(mapStateToProps)(NeedsAuthComponent);
  const HoistedComponent = hoistNonReactStatic(NeedsAuth, WrappedComponent);
  HoistedComponent.WrappedComponent = WrappedComponent;
  HoistedComponent.displayName = `NeedsAuth(${getDisplayName(WrappedComponent)})`;
  HoistedComponent.handleRedirect = async function _handleRedirect(args) {
    const isAuthenticatedUser = selectIsAuthenticatedUser(args.getState());
    if (!isAuthenticatedUser) {
      // max-age=1: cache for 1second in the browser
      //    should anonymous user fetch this, then auth, browser cache should
      //    not be used anymore.
      //    We do not trust max-age=0 to have a reliable behavior across browser
      //    vendor, one second is good enough, and show similar results
      // s-max-age=600: cache for 10minutes in proxies
      // stale-while-revalidate=3600: serve cached response from proxy,
      //    while proxy retrieves up-to-date version
      // stale-if-error=3600: serve cached response from proxy,
      //    while backend is broken.
      // Use `X-Cache-Control-After-Gzip` to set `Cache-Control` after gzip.
      args.res.header('X-Cache-Control-After-Gzip', 'max-age=1, s-maxage=600, stale-while-revalidate=3600, stale-if-error=3600, public, no-transform');
    }
    await handleRedirect(args);
    // Call child handleRedirect if any.
    const wrappedHandleRedirect = getDataDependency(WrappedComponent, 'handleRedirect');
    if (wrappedHandleRedirect) {
      await wrappedHandleRedirect(args);
    }
  };
  return HoistedComponent;
};